import script from "./ai-assistant.vue?vue&type=script&setup=true&lang=js"
export * from "./ai-assistant.vue?vue&type=script&setup=true&lang=js"

import "./ai-assistant.vue?vue&type=style&index=0&id=6c25f710&lang=css"

const __exports__ = script;

export default __exports__